import React, { useContext } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJs,
  ArcElement,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
} from "chart.js";
import annotationPlugin from "chartjs-plugin-annotation";
import ChartDataLabels from "chartjs-plugin-datalabels";
import LoadingSpinner from "../LoadingSpinner.js";
import {
  INFLUENCING_CRITERIA_LIST_1,
  QUESTION_6_1,
} from "../../constants/constants.js";
import { useAPI } from "../../ApiContext.js";
import { Card } from "react-bootstrap";
import { ColorPaletteContext } from "../../App.js";
import { influencingCriteriaBarDataQ6_1 } from "../../Helper.js";

ChartJs.register(
  Tooltip,
  Legend,
  ArcElement,
  BarElement,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  annotationPlugin,
  ChartDataLabels
);

function InfluencingCriteriaBarChartQ6_1(props) {
  const { dashboardData } = useAPI();

  const colorPaletteContext = useContext(ColorPaletteContext);

  const { colorPaletteState } = colorPaletteContext;

  function getChartData() {
    return {
      labels: INFLUENCING_CRITERIA_LIST_1.map((item, index) => item.value),
      datasets: [
        {
          label: "Influencing criteria: Equipment reprocessing",
          data: influencingCriteriaBarDataQ6_1(dashboardData.data, {
            countryFilterValue: props.countryFilterValue,
            roleFilterValue: props.roleFilterValue,
          }),
          borderColor: colorPaletteState[0],
          backgroundColor: colorPaletteState[0],
          borderWidth: 1,
          hoverOffset: 4,
        },
      ],
    };
  }

  function getOptions() {
    return {
      responsive: true,
      maintainAspectRatio: false,
      layout: {
        padding: 20,
      },
      plugins: {
        tooltip: {
          callbacks: {
            title: (context) => {
              return context[0].label.replaceAll(",", " ");
            },
          },
        },
        legend: {
          display: false,
        },
        datalabels: {
          formatter: (value) => {
            return value + " %";
          },
          anchor: "end",
          align: "top",
          color: "grey",
          font: {
            weight: "bold",
            size: 10,
          },
        },
      },
      scales: {
        x: {
          grid: {
            display: false,
          },
          ticks: {
            font: {
              size: 8,
            },
          },
        },
        y: {
          grid: {
            display: false,
          },
          display: false,
        },
      },
    };
  }

  return (
    <Card>
      <Card.Header>{QUESTION_6_1}</Card.Header>
      <Card.Body>
        {dashboardData.data && dashboardData.data.length > 0 ? (
          <div style={{ width: "100%", height: "60vh" }}>
            <Bar options={getOptions()} data={getChartData()} />
          </div>
        ) : (
          <LoadingSpinner />
        )}
      </Card.Body>
    </Card>
  );
}
export default InfluencingCriteriaBarChartQ6_1;
